module.exports = __webpack_public_path__ + "static/media/icon_recharge_location.5e1aad14.png";